export const REFETCH_INTERVAL = 5000;
export const MAX_ERROR_COUNT = 3;
export const INVALID_SESSION_STATUS = [3];
export const INVALID_REQUEST_ACCESS_STATUS = [4, 5, 6, 7];

export const LISTROW_TYPES = {
  SESSION: 'session',
  ENDPOINT: 'endpoint',
  ROLE: 'role',
  ACCOUNT: 'account',
};

export const AD_RDP = 'adrdp';

/**
 * Gateway state values indicating the native RDP gateway is ready to serve
 * an .rdp file download. Compared against `gatewayStates[].state` in the
 * session status poll response. State 2 = "ready" as defined by the gateway
 * orchestration layer (the value originates from the backend session status
 * API, not from the rdpsession or PAMMS repos directly).
 */
export const NATIVE_RDP_GATEWAY_READY_STATES = [2];
